import axios from 'axios';

const instance= axios.create({
	baseURL: 'https://burger-builder-7ad47.firebaseio.com/'
})

export default instance;


// WEBPACK FOOTER //
// ./src/axios-orders.js